import { UserPreferences } from './typings'

export const optimisticallySetPreference = <TPreferenceKey extends keyof UserPreferences>(
  preferenceName: TPreferenceKey,
  value: UserPreferences[TPreferenceKey],
) => {
  return {
    type: 'SET_USER_PREFERENCE',
    payload: {
      name: preferenceName,
      value,
    },
  }
}

const actions = {
  optimisticallySetPreference,
}

export default actions
